let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1TgGg")).then(() => parcelRequire('ePHA7'));